import Vue from 'vue'
import Router from 'vue-router'
import toLogin from "@/libs/login";

// developmentTeam
Vue.use(Router)

const router =  new Router({
  routes: [
    // 首页
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/components/index'],resolve),
      meta:{
        navShow: true
      },
    },
    // 团队管理
    {
      path: '/Management',
      name: 'Management',
      component: resolve => require(['@/components/management'],resolve),
      meta:{
        navShow:true
      },
    },
    ,
    // 业绩
    {
      path: '/Achievement',
      name: 'Achievement',
      component: resolve => require(['@/components/achievement'],resolve),
      meta:{
        navShow:true
      },
    },
    // 我的
    {
      path: '/me',
      name: 'Me',
      component: resolve => require(['@/components/me'],resolve),
      meta:{navShow:true}
    },
    {
      path: '/search',
      name: 'Search',
      component: resolve => require(['@/components/Search'],resolve),
      meta:{navShow:true}
    },
    // 信贷方案
    {
      path: '/sedCreditPlan',
      name: 'sedCreditPlan',
      component: resolve => require(['@/components/sedCreditPlan'],resolve),
      meta:{navShow:true}
    },
    // 公告详情
    {
      path: '/NoticeDetails',
      name: 'NoticeDetails',
      component: resolve => require(['@/components/NoticeDetails'],resolve),
      meta:{navShow:false}
    },
    // 新闻详情
    {
      path: '/xwdetail',
      name: 'xwdetail',
      component: resolve => require(['@/components/xwdetail.vue'],resolve),
      meta:{navShow:false}
    },
    // 答题
    {
      path: '/question',
      name: 'question',
      component: resolve => require(['@/components/question'],resolve),
      meta:{navShow:false}
    },
    // 在线采票
    {
      path: '/collect',
      name: 'collect',
      component: resolve => require(['@/components/collect'],resolve),
      meta:{navShow:false}
    },
    {
      path: '/poster',
      name: 'poster',
      component: resolve => require(['@/components/poster'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/poster/more/:id',
      name: 'poster_more',
      component: resolve => require(['@/components/PosterMore'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/build_poster/:id',
      name: 'build_poster',
      component: resolve => require(['@/components/BuildPoster'],resolve),
      meta: {navShow:false}
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/components/login'],resolve),
      meta:{navShow:false}
    },
    // 成员详情  numberDetails
    {
      path: '/numberDetails',
      name: 'numberDetails',
      component: resolve => require(['@/components/numberDetails'],resolve),
      meta:{navShow:false}
    },
    // 提现  cashMount
    {
      path: '/cashMount',
      name: 'cashMount',
      component: resolve => require(['@/components/cashMount'],resolve),
      meta:{navShow:false}
    },
    // 资金明细  financialDetails
    {
      path: '/financialDetails',
      name: 'financialDetails',
      component: resolve => require(['@/components/financialDetails'],resolve),
      meta:{navShow:false}
    },// 手机号登录  mobileLogin
    {
      path: '/mobileLogin',
      name: 'mobileLogin',
      component: resolve => require(['@/components/mobileLogin'],resolve),
      meta:{navShow:false}
    },// 注册  register
    {
      path: '/register',
      name: 'register',
      component: resolve => require(['@/components/register'],resolve),
      meta:{navShow:false}
    },
    // 密码登录 passwordLogin
    {
      path: '/passwordLogin',
      name: 'passwordLogin',
      component: resolve => require(['@/components/passwordLogin'],resolve),
      meta:{navShow:false}
    },
    // 进件返佣 IntoCommission
    {
      path: '/IntoCommission',
      name: 'IntoCommission',
      component: resolve => require(['@/components/IntoCommission'],resolve),
      meta:{navShow:false}
    },
     // 分享 share
     {
      path: '/share',
      name: 'share',
      component: resolve => require(['@/components/share'],resolve),
      meta:{navShow:false}
    },
     // 录单
     {
      path: '/recording',
      name: 'recording',
      component: resolve => require(['@/components/recording'],resolve),
      meta:{navShow:false}
    },
    // 申请贷款  ApplyFor
    {
      path: '/applyfor',
      name: 'applyfor',
      component: resolve => require(['@/components/applyfor'],resolve),
      meta:{navShow:false}
    },
     // 进件管理  groupsPassage
     {
      path: '/groupsPassage',
      name: 'groupsPassage',
      component: resolve => require(['@/components/groupsPassage'],resolve),
      meta:{navShow:false}
    },
    // developmentTeam 发展团队
    {
      path: '/developmentTeam',
      name: 'developmentTeam',
      component: resolve => require(['@/components/developmentTeam'],resolve),
      meta:{navShow:false}
    },
    {
      path: '/mykefu',
      name: 'mykefu',
      component: resolve => require(['@/components/mykefu'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/regulations',
      name: 'regulations',
      component: resolve => require(['@/components/regulations'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/teamfenrun',
      name: 'teamfenrun',
      component: resolve => require(['@/components/teamfenrun'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/Bankcard',
      name: 'Bankcard',
      // component: Bankcard,
      component: resolve => require(['@/components/Bankcard'],resolve),
      meta: {navShow:false}
    },
    {
      path: '/autonym',
      name: 'autonym',
      component: resolve => require(['@/components/autonym'],resolve),
      meta: {navShow:false}
    },
    //筛选
    {
      path: '/screen',
      name: 'screen',
      component: resolve => require(['@/components/screen'],resolve),
      meta: {navShow:false}
    },
    //筛选
    {
      path: '/infoService',
      name: 'infoService',
      component: resolve => require(['@/components/queryInfo'],resolve),
      meta: {navShow:false}
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.path == "/login"){
    localStorage.setItem("odata","1")
  }else{
    localStorage.setItem("odata","0")
  }
  // var token = window.localStorage.getItem('token');
  // if(!token) {
  //   if(to.name == 'mobileLogin') next();
  //   return toLogin(to.name, to.fullPath, true, '/#'+to.fullPath);
  // }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js